import {
    ReportPeriodTranslationPipe,
    reportPeriodTranslationPipe
} from "./report-period/ReportPeriodNamePipe";
import {
    reportTypeTranslationPipe,
    ReportTypeTranslationPipe
} from "./report-type/ReportTypeNamePipe";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.pipes`;

    return angular.module(moduleName, [])
                  .filter(ReportPeriodTranslationPipe, reportPeriodTranslationPipe)
                  .filter(ReportTypeTranslationPipe, reportTypeTranslationPipe)
                  .name;
}
